import "./AdManagerBannersFilter.scss";
import FilterDateInput from "@/components/Common/FilterDateInput/FilterDateInput.vue";
import { canParseJson } from "@/helpers/commonHelper";

export default {
  name: "AdManagerBannersFilter",
  props: ["filter", "groups", "zones"],
  components: {
    FilterDateInput
  },
  data: () => ({
    activeOptions: [
      { label: "Alle", value: -1 },
      { label: "Nur Aktive", value: 1 },
      { label: "Nur Inaktive", value: 0 }
    ],
    dialog: false
  }),
  mounted() {
    this.getContentFromLocalStorage();
  },
  methods: {
    getContentFromLocalStorage() {
      this.getLocalStorageItems();
      this.updateFilter();
    },
    getLocalStorageItems() {
      let startDate = localStorage.getItem("adManagerBannersStartDate");
      if (!startDate) {
        const tmp = new Date();
        tmp.setHours(0, 0, 0, 0);
        startDate = tmp.toISOString();
      }
      this.filter.start_date = startDate;

      let endDate = localStorage.getItem("adManagerBannersEndDate");
      if (!endDate) {
        endDate = "";
      }
      this.filter.end_date = endDate;

      const zones = localStorage.getItem("adManagerBannersZones");
      this.filter.zones = canParseJson(zones) ? JSON.parse(zones) : [];

      const groups = localStorage.getItem("adManagerBannersGroups");
      this.filter.groups = canParseJson(groups) ? JSON.parse(groups) : [];

      this.filter.deleted = Number(
        localStorage.getItem("adManagerBannersDeleted")
      );

      const active = localStorage.getItem("adManagerBannersActive") ?? -1;
      this.filter.active = Number(active);
    },

    setLocalStorageItems() {
      localStorage.setItem("adManagerBannersStartDate", this.filter.start_date);
      localStorage.setItem("adManagerBannersEndDate", this.filter.end_date);
      localStorage.setItem(
        "adManagerBannersZones",
        JSON.stringify(this.filter.zones)
      );
      localStorage.setItem(
        "adManagerBannersGroups",
        JSON.stringify(this.filter.groups)
      );
      localStorage.setItem("adManagerBannersDeleted", this.filter.deleted);
      localStorage.setItem("adManagerBannersActive", this.filter.active);
    },
    setFilterStartDate() {
      if (this.filter.start_date) {
        const startDate = new Date(this.filter.start_date);
        startDate.setHours(0, 0, 0);
        this.filter.start_date = startDate.toISOString();
        if (this.endBeforeStartDate) {
          return;
        }
      }
      this.updateFilter();
    },
    setFilterEndDate() {
      if (this.filter.end_date) {
        const endDate = new Date(this.filter.end_date);
        endDate.setHours(23, 59, 59);
        this.filter.end_date = endDate.toISOString();
        if (this.endBeforeStartDate) {
          return;
        }
      }
      this.updateFilter();
    },
    setDeleted() {
      this.filter.deleted = Number(this.filter.deleted);
      this.updateFilter();
    },
    updateFilter() {
      this.setLocalStorageItems();
      this.$emit("applyFilter");
    },
    async resetFilter() {
      const tmp = new Date();
      tmp.setHours(0, 0, 0, 0);
      this.filter.start_date = tmp.toISOString();
      this.filter.end_date = "";
      this.filter.zones = [];
      this.filter.groups = [];
      this.filter.active = -1;
      delete this.filter.deleted;
      this.updateFilter();
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    endBeforeStartDate() {
      const { start_date, end_date } = this.filter;
      if (!start_date || !end_date) {
        return false;
      }
      return new Date(start_date) >= new Date(end_date);
    }
  }
};
